import {Box, Typography} from "@mui/material";
import {NavBar} from "../../organisms/NavBar/NavBar";
import {TrendFinder} from "../QueryPage/components/TrendFinder/TrendFinder";
import {useSdqlQuery} from "../../../hooks/utilHooks/useNbaSdqlQuery/useSdqlQuery";
import {useLocation} from "react-router-dom";
import type {Sport} from "../../../types/types";
import {useGetSearchTrends} from "../../../hooks/getSearchTrends/getSearchTrends";
import {useQuerySdqlSummaryData} from "../../../hooks/getNbaMatchups/querySdqlData";

export const TrendFinderPage = ({}) => {

    const {pathname} = useLocation();
    const sport = pathname.replace('/', '').replace('-trend-finder', '') || ''

    const {
        queryString,
        handleSdqlStringChange
    } = useSdqlQuery(sport)

    const searchTrendData = useGetSearchTrends({
        sport,
        noMatchupSelected: true,
    })
    const {teamTrends, oTeamTrends, seasonTrends} = searchTrendData?.data?.searchTrends || {};

    const {
        data: sdqlSummaryData,
        error: sdqlSummaryError,
        loading: sdqlSummaryDataLoading
    } = useQuerySdqlSummaryData(queryString, sport) || {}

    return (
        <Box>
            <NavBar />
            <Typography
                component="p"
                variant="h6"
                align="center"
                color="grey"
                fontWeight={100}
                pl={3.5}
                pr={3.5}
                mt={2}
            >
                {sport.toUpperCase()} Trend-finder
            </Typography>
            <TrendFinder
                queryString={queryString}
                sport={sport as Sport}
                handleChange={handleSdqlStringChange}
                teamTrends={teamTrends}
                oTeamTrends={oTeamTrends}
                seasonTrends={seasonTrends}
            />
        </Box>
    )
}